import axios from "axios";

const BASE = "/v1/import";

function saveBlob(data, filename) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

function filenameFrom(response, fallback) {
  const header = response.headers?.["content-disposition"] || "";
  const match = header.match(/filename="?([^";]+)"?/i);
  return match ? match[1] : fallback;
}

export async function downloadTemplate(entity) {
  const response = await axios.get(`${BASE}/template`, {
    responseType: "blob",
    params: entity && entity !== "all" ? { entity } : undefined,
  });
  const prefix = entity && entity !== "all" ? entity : "data";
  saveBlob(response.data, filenameFrom(response, `${prefix}_import_template.xlsx`));
}

export async function getColumns() {
  const { data } = await axios.get(`${BASE}/columns`);
  return data;
}

export async function uploadImportFile(file, entity, onProgress) {
  const formData = new FormData();
  formData.append("file", file);
  if (entity) formData.append("entity", entity);
  const { data } = await axios.post(`${BASE}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (event) => {
      if (onProgress && event.total) onProgress(Math.round((event.loaded * 100) / event.total));
    },
  });
  return data;
}

export async function listImportJobs(limit = 10) {
  const { data } = await axios.get(`${BASE}/jobs`, { params: { limit } });
  return data;
}

export async function getImportJob(jobid) {
  const { data } = await axios.get(`${BASE}/jobs/${jobid}`);
  return data;
}

export async function getImportRows(jobid, params) {
  const { data } = await axios.get(`${BASE}/jobs/${jobid}/rows`, { params });
  return data;
}

export async function startImport(jobid) {
  const { data } = await axios.post(`${BASE}/jobs/${jobid}/commit`);
  return data;
}

export async function downloadProblemRows(jobid) {
  const response = await axios.get(`${BASE}/jobs/${jobid}/problems`, { responseType: "blob" });
  saveBlob(response.data, filenameFrom(response, "skipped_rows.xlsx"));
}

export async function discardImportJob(jobid) {
  const { data } = await axios.delete(`${BASE}/jobs/${jobid}`);
  return data;
}
